module.exports = __webpack_public_path__ + "img/29.e4ee4214.jpg";